import { useEffect, useState } from "react"
import Etapa0 from "./CreateProductEtapas/FirstEtapa.js"
import CreateProductHeader from "./CreateProductHeader"
import Etapa1 from "./CreateProductEtapas/SecondEtapa.js"
import Etapa2 from "./CreateProductEtapas/thirdEtapa.js"
import Etapa3 from "./CreateProductEtapas/fourthEtapa.js"
import axiosInstance from "../../Services/Api.js"


const CreateProduct = ({ setShowListProducts }) => {
    const [etapas, setEtapas] = useState(0)
    const [productTypeSelected, setProductType] = useState('')
    const [showselectionType, setShowSelectionType] = useState(true)
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [isUpdate,setIsUpdate] = useState(false)
    const [productData, setProductData] = useState({
        name: '',
        description: '',
        category: 'infoproduct',
        language: 'ptbr',
        currency: 'R$',
        salesPage: '',
        supportEmail: '',
        producerName: '',
        image: null,
        archive: null,
    })

    useEffect(() => {
        (async () => {
            const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
            const urlProductId = hashParams.get('productId');
            const isUpdate = !!urlProductId;
            setIsUpdate(isUpdate)
            try {
                // 1. Extrair productId do hash da URL
                const hashQuery = window.location.hash.split('?')[1] || '';
                const searchParams = new URLSearchParams(hashQuery);
                const productId = searchParams.get('productId');

                // 2. Verificar se o parâmetro existe
                if (!productId) {
                    console.log('Nenhum productId na URL');
                    return;
                }

                // 3. Fazer a requisição com o ID
                const response = await axiosInstance.get(`/checkout/product?productId=${productId}`);
                setProductData({
                    id: response.data.product.id || null,
                    category: response.data.product.categoryId?.toString() || 1,
                    language: response.data.product.lang || 'pt',
                    currency: response.data.product.currency || 'BRL',
                    name: response.data.product.name || '',
                    description: response.data.product.description || '',
                    salesPage: response.data.product.salePage || '',
                    supportEmail: response.data.product.suportEmail || '',
                    producerName: response.data.product.productorName || '',
                    image: response.data.product.image || null,
                    archive: response.data.product.archive || null,
                    price: response.data.product.price ?
                        parseFloat(response.data.product.price.replace(',', '.')) : 0,
                    productType: response.data.product.productType?.toString() || '0',
                    paymentType: response.data.product.defaultPaymentType || 1,
                    sendType: response.data.product.sendType || 1,
                    archive: response.data.product.archive || null,
                    createdAt: response.data.product.created_at,
                    updatedAt: response.data.product.updated_at
                })
                if (response.data.product.image) {
                    setSelectedImage(process.env.REACT_APP_API_URL + "/" + response.data.product.image)
                }
                if (response.data.product.archive) {
                    setSelectedProduct(response.data.product.archive)
                }
            } catch (e) {

            }
        })()
    }, [])
    const hanDleSelectProductType = (type) => {
        setShowSelectionType(false)
        setProductType(type)
        handleProductData({ ...productData, productType: type })
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setSelectedImage(null);
        }
    }

    const handleProductData = (newData) => {
        setProductData(prev => ({
            ...prev,
            ...newData
        }));
    };

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const handleSubmit = async () => {
        try {
            setLoading(true);
            setError('');
            const errors = [];

            // Criar FormData para envio
            const formData = new FormData();

            // Adicionar campos ao FormData
            const addField = (name, value) => {
                if (value !== undefined && value !== null) {
                    formData.append(name, value);
                }
            };

            // Mapeamento de campos
            addField('name', productData.name?.trim());
            addField('categoryId', 1);
            addField('description', productData.description?.trim());
            addField('lang', 'pt');
            addField('currency', 'BRL');
            addField('salePage', productData.salesPage?.trim());
            addField('suportEmail', productData.supportEmail?.trim());
            addField('productorName', productData.producerName?.trim());
            addField('paymentType', '1');
            addField('defaultPaymentType', '1');
            addField('sendType', Number(productData.sendType));
            addField('productType', Number(productData.productType));
            addField('price', parseFloat(productData.price).toFixed(2));
            addField('image', productData.image);
            addField('archive', productData.archive);
            // Validações obrigatórias
            const requiredFields = {
                name: 'Nome',
                categoryId: 'Categoria',
                description: 'Descrição',
                lang: 'Idioma',
                currency: 'Moeda',
                salePage: 'Página de vendas',
                suportEmail: 'E-mail de suporte',
                productorName: 'Nome do produtor',
                sendType: 'Tipo de envio',
                productType: 'Tipo de produto',
                price: 'Preço',
                archive: 'Arquivo',
                image: 'Imagem'
            };

            // Verificar campos obrigatórios
            Object.entries(requiredFields).forEach(([field, name]) => {
                const value = formData.get(field);
                if (!value && value !== 0) {
                    errors.push(`${name} é obrigatório`);
                }
            });

            // Validações específicas
            if (productData.name?.length > 255) {
                errors.push('Nome deve ter no máximo 255 caracteres');
            }

            // if (productData.language?.length !== 2) {
            //     errors.push('Idioma deve ter exatamente 2 caracteres');
            // }

            if (!isValidUrl(productData.salesPage)) {
                errors.push('URL da página de vendas inválida');
            }

            if (!isValidEmail(productData.supportEmail)) {
                errors.push('E-mail de suporte inválido');
            }

            if (productData.producerName?.length > 255) {
                errors.push('Nome do produtor deve ter no máximo 255 caracteres');
            }

            if (![1, 2].includes(Number(productData.sendType))) {
                errors.push('Tipo de envio inválido (1 ou 2)');
            }

            if (![1, 2, 0].includes(Number(productData.productType))) {
                errors.push('Tipo de produto inválido (0,1,2)');
            }

            // Validação de arquivos
            if (productData.image) {
                if (!isUpdate && !(productData.image instanceof File)) {
                    errors.push('Imagem inválida');
                } else if(productData.image instanceof File) {
                    if (productData.image.size > 2048 * 1024) {
                        errors.push('Imagem não pode exceder 2MB');
                    }
                    if (!isUpdate && !["image/jpeg", "image/png", "image/jpg", "image/gif", "image/webp"].includes(productData.image.type)) {
                        errors.push('Formato de imagem inválido (JPEG, PNG, JPG ou GIF)');
                    }
                }
            }

            if (productData.archive) {
                if (!isUpdate && !(productData.archive instanceof File)) {
                    errors.push('Arquivo inválido');
                } else {
                    if (productData.archive.size > 50000 * 1024) {
                        errors.push('Arquivo não pode exceder 50MB');
                    }
                }
            }

            // Verificar se há erros
            if (errors.length > 0) {
                alert(errors.join('\n'));
                return
            }

            // Adicionar arquivos ao FormData
            if (productData.image instanceof File) {
                formData.append('image', productData.image);
            }

            if (productData.archive instanceof File) {
                formData.append('archive', productData.archive);
            }

            // Chamada à API
            const url = isUpdate
                ? `/checkout/updateProduct?productId=${productData.id}`
                : '/checkout/product';

            const response = await axiosInstance.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                alert('Produto salvo com sucesso!');
                setProductData({...productData,id:response.data.data.id})
                setEtapas(2);
            }

        } catch (error) {
            console.error('Erro ao salvar produto:', error);
            if (error.response && error.response.status === 401) { // Check for response status
                window.localStorage.removeItem('token');
                window.location.reload();
            }
            if (error.response && error.response.status === 400) { // Check for response status
               alert(error.response.data.error)
               setEtapas(2);
            }
            const message = error.response?.data?.message || error.message;
            setError(typeof message === 'object' ? Object.values(message).flat().join('\n') : message);
        } finally {
            setLoading(false);
        }
    };

    // Funções auxiliares
    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };


    return (
        <div className="mt-8  px-4">
            <div className="cursor-pointer mb-3" onClick={() => { setShowListProducts(true) }}>Voltar</div>
            <CreateProductHeader etapas={etapas} setEtapas={setEtapas} />
            {etapas === 0 &&
                <Etapa0 selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} productData={productData} handleProductData={handleProductData} setSelectedImage={setSelectedImage} selectedImage={selectedImage} handleFileChange={handleFileChange} productTypeSelected={productTypeSelected} hanDleSelectProductType={hanDleSelectProductType} setEtapas={setEtapas} />
            }
            {etapas === 1 &&
                <Etapa1 productData={productData} handleProductData={handleProductData} handleSubmit={handleSubmit} isUpdate={isUpdate}/>
            }
            {etapas === 2 &&
                <Etapa2 productData={productData} setEtapas={setEtapas} />
            }
            {etapas === 3 &&
                <Etapa3 productData={productData} setEtapas={setEtapas} />
            }
        </div>
    )
}

export default CreateProduct